import { type ComponentType, useEffect, useState } from "react";

import getAuthClient from "@skilitics/designer-auth";

import { RouteErrorView } from "./RouteErrorView.tsx";

// Check for required type of context for a route component (e.g. after switching workspaces):
// - admin: a workspace admin
export function requireAdmin(Component: ComponentType): ComponentType {
  function RequiresAdmin() {
    // useWorkspaceInfo()?.role depends on the workspace list being loaded...
    // For now look at the current API token state which should always be set
    // if we're rendering authenticated UI.
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
      const client = getAuthClient();
      return client.watch(() => {
        setRole(client.apiToken ? client.apiToken.role : null);
      });
    }, []);

    // Workspace being null means the workspace list is being loaded...
    if (role !== "admin") {
      return <RouteErrorView code="requires-admin" />;
    }

    return <Component />;
  }

  return RequiresAdmin;
}
